<div class="wrapper border rounded-[5px] p-[15px]">
  @if (reports.length) {
    @for (report of reports; track report.id; let last = $last) {
      <div class="report-entry" [class.report-entry-divider]="!last">
        <div class="uploader-row flex flex-row items-center justify-between gap-[12px] mb-[10px]">
          <div class="uploader text-type-11">
            Uploaded
            by {{ report?.createdBy?.first_name }} {{ report?.createdBy?.last_name }}
          </div>
          @if (resultBadge(report.result); as badge) {
            <div class="result-badge" [ngClass]="badge.class">{{ badge.label }}</div>
          }
        </div>
        <div class="details text-type-11 mb-[20px]">
          {{ report?.created_at | dateFormat:'very-long' }}
        </div>
        @if (report?.comment) {
          <div class="row flex flex-col mb-[20px]">
            <div class="label">
              Report Note:
            </div>
            <div class="value">
              {{ report?.comment }}
            </div>
          </div>
        }
        @if (report.mediaFiles?.length) {
          <app-pictures-section
            [isEditable]="false"
            [label]="'attachments:'"
            [pictures]="report.mediaFiles"
            class="pictures-section mb-[40px]"
            />
        }
      </div>
    }
    @if (labRecommendation) {
      <div class="row flex flex-col mb-[20px]">
        <div class="label">
          Lab Recommendation:
        </div>
        <div class="result-display flex flex-row items-center gap-[8px] mt-[8px]">
          @if (data?.lab_recommendation === 'passed') {
            <mat-icon svgIcon="green-check" class="result-icon"></mat-icon>
          } @else if (data?.lab_recommendation === 'failed') {
            <mat-icon svgIcon="failed-orange" class="result-icon"></mat-icon>
          }
          <span class="result-text">{{ labRecommendation }}</span>
        </div>
      </div>
    }
  } @else {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [add]="true"
      [label]="'attachments: *'"
      [pictures]="mediaFiles"
      class="pictures-section mb-[40px]"
      />
    <div class="toggle-section mb-[30px]">
      <app-toggle-buttons
        [parentFormGroup]="form"
        controlName="result"
        heading="Test result *"
      ></app-toggle-buttons>
      @if (form.controls.result.touched && form.controls.result.hasError('required')) {
        <mat-error>
          Test result is <strong>required</strong>
        </mat-error>
      }
    </div>
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [controlName]="'comment'"
      [error]="errorMessages['comment']"
      [label]="'report Note'"
      [parentFormGroup]="form"
      class="mb-[30px]"
      />
    <div class="action-section mb-[20px]">
      <app-primary-button [isDisabled]="!form.valid || !mediaFiles?.length" (handleClick)="save()">
        Upload
      </app-primary-button>
    </div>
  }
</div>
